import { render } from "./index.vue?vue&type=template&id=34f2648c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/modal-footer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f2648c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f2648c', __exports__)) {
    api.reload('34f2648c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=34f2648c", () => {
    api.rerender('34f2648c', render)
  })

}


export default __exports__